import React from "react";
import { useField, useFormikContext } from "formik";

// material
import {
  Autocomplete,
  Container,
  FormControl,
  MenuItem,
  Typography,
  TextField,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";

// ----------------------------------------------------------------------

const textChoice = [
  { label: "Experiment/Research and Data collection" },
  {
    label:
      "Obtaining result/Selecting journal/Writing publication for submission"
  }
];

export default function UploadFormPage2SecA(props) {
  const formikProps = useFormikContext();

  const {
    formField: {
      whatYourStatus,
      AssessMainProgressAchieved,
      ListJournalSubject,
      researchPlanRelevantIndicates,
      additionalInformNote,
      additionalDocument
    }
  } = props;

  const [whatYourStatusField, whatYourStatusMeta] = useField(whatYourStatus);
  const [AssessMainProgressAchievedField, AssessMainProgressAchievedMeta] =
    useField(AssessMainProgressAchieved);
  const [ListJournalSubjectField, ListJournalSubjectMeta] =
    useField(ListJournalSubject);
  const [
    researchPlanRelevantIndicatesField,
    researchPlanRelevantIndicatesMeta
  ] = useField(researchPlanRelevantIndicates);
  const [additionalInformNoteField, additionalInformNoteMeta] =
    useField(additionalInformNote);
  const [additionalDocumentField, additionalDocumentMeta] =
    useField(additionalDocument);

  return (
    <Page title="UploadFormPage2SecA">
      <Container maxWidth="xl">
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <FormControl fullWidth>
            <Typography variant="subtitle2">{whatYourStatus.label}</Typography>
            <Autocomplete
              freeSolo
              options={textChoice?.map((option) => option.label)}
              onChange={(e, value) =>
                formikProps.setFieldValue(whatYourStatus.name, value)
              }
              renderInput={(params) => (
                <TextField
                  name={whatYourStatusField.name}
                  value={whatYourStatusField.value}
                  onChange={(e) => whatYourStatusField.onChange(e)}
                  error={Boolean(
                    whatYourStatusMeta.touched && whatYourStatusMeta.error
                  )}
                  helperText={
                    whatYourStatusMeta.touched && whatYourStatusMeta.error
                  }
                  {...params}
                />
              )}
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {AssessMainProgressAchieved.label}
            </Typography>
            <TextField
              select
              variant="outlined"
              name={AssessMainProgressAchievedField.name}
              value={AssessMainProgressAchievedField.value}
              onChange={(e) => AssessMainProgressAchievedField.onChange(e)}
              error={Boolean(
                AssessMainProgressAchievedMeta.touched &&
                  AssessMainProgressAchievedMeta.error
              )}
              helperText={
                AssessMainProgressAchievedMeta.touched &&
                AssessMainProgressAchievedMeta.error
              }
            >
              <MenuItem value={"Less than 50%"}>Less than 50%</MenuItem>
              <MenuItem value={"60%"}>60%</MenuItem>
              <MenuItem value={"70%"}>70%</MenuItem>
              <MenuItem value={"80%"}>80%</MenuItem>
              <MenuItem value={"90%"}>90%</MenuItem>
              <MenuItem value={"Complete"}>Complete</MenuItem>
            </TextField>
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {ListJournalSubject.label}
            </Typography>
            <TextField
              multiline
              rows={4}
              name={ListJournalSubjectField.name}
              value={ListJournalSubjectField.value}
              onChange={(e) => ListJournalSubjectField.onChange(e)}
              error={Boolean(
                ListJournalSubjectMeta.touched && ListJournalSubjectMeta.error
              )}
              helperText={
                ListJournalSubjectMeta.touched && ListJournalSubjectMeta.error
              }
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {researchPlanRelevantIndicates.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={researchPlanRelevantIndicatesField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `researchPlanRelevantIndicates.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                researchPlanRelevantIndicatesMeta.touched &&
                  researchPlanRelevantIndicatesMeta.error
              )}
              helperText={
                researchPlanRelevantIndicatesMeta.touched &&
                researchPlanRelevantIndicatesMeta.error
              }
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {additionalInformNote.label}
            </Typography>
            <TextField
              multiline
              rows={4}
              name={additionalInformNoteField.name}
              value={additionalInformNoteField.value}
              onChange={(e) => additionalInformNoteField.onChange(e)}
              error={Boolean(
                additionalInformNoteMeta.touched &&
                  additionalInformNoteMeta.error
              )}
              helperText={
                additionalInformNoteMeta.touched &&
                additionalInformNoteMeta.error
              }
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {additionalDocument.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={additionalDocumentField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `additionalDocument.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                additionalDocumentMeta.touched && additionalDocumentMeta.error
              )}
              helperText={
                additionalDocumentMeta.touched && additionalDocumentMeta.error
              }
            />
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
